module.exports = __webpack_public_path__ + "img/cabbage-soup.ab08b7e3.jpg";